import { motion, AnimatePresence } from "framer-motion";
import React from "react";

const Fade = ({
  children,
  isVisible,
  onExitComplete,
}: {
  children: React.ReactNode;
  isVisible: boolean;
  onExitComplete?: (() => void);
}) => {
  return (
    <AnimatePresence presenceAffectsLayout={true} onExitComplete={onExitComplete}>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Fade;
